import { useEffect, useId, useRef } from 'react'
import { createPortal } from 'react-dom'

/** Same modal and focus behavior as the task review confirmations. */
export function StopExperimentConfirmation({ busy, error, returnFocus, onCancel, onConfirm }: {
  busy: boolean
  error: string
  returnFocus: HTMLButtonElement | null
  onCancel: () => void
  onConfirm: () => Promise<void>
}) {
  const dialog = useRef<HTMLDialogElement>(null)
  const id = useId()
  useEffect(() => {
    const element = dialog.current!
    element.showModal()
    element.querySelector<HTMLButtonElement>('button')?.focus()
    return () => { element.close(); returnFocus?.focus() }
  }, [returnFocus])
  return createPortal(<dialog ref={dialog} className="review-confirmation"
    aria-labelledby={`${id}-title`} aria-describedby={`${id}-description`}
    onCancel={event => { event.preventDefault(); if (!busy) onCancel() }}>
    <h2 id={`${id}-title`}>Stop this experiment?</h2>
    <p id={`${id}-description`}>Active EC2 nodes will be terminated.</p>
    {error && <p className="note err" role="alert">{error}</p>}
    <div className="row">
      <button autoFocus disabled={busy} onClick={onCancel}>Cancel</button>
      <button className="experiment-stop" disabled={busy} onClick={() => void onConfirm()}>
        {busy ? 'Stopping…' : 'Stop experiment'}
      </button>
    </div>
  </dialog>, document.body)
}
